import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MapControls } from '../utilities/MapControls/MapConrols';
import { SocketService } from '../socket.service';
import { CONSTANTS } from '../utilities/Constants';
import { ActivatedRoute } from '@angular/router';
import { MainService } from '../services/optimizer-service/optimizer.service';
import { MatDialog } from '@angular/material';
import { QuickDialog } from '../utilities/Dialog/QuickDialog';
import { HaversineFormula } from '../DataStructures/DistanceDuration/DistanceDuration';
declare var google: any;
@Component({
  selector: 'app-tracking-link',
  templateUrl: './tracking-link.component.html',
  styleUrls: ['./tracking-link.component.css']
})
export class TrackingLinkComponent implements OnInit {
  link = null;
  d = null;
  distance = null;
  time = null;
  payload = null;
  driverMarkers = {

  };
  driverMap = {

  };
  @ViewChild('map') mapReference: ElementRef;
  constructor(private dialog: MatDialog, private main: MainService, private route: ActivatedRoute, private mapControls: MapControls, private socketService: SocketService) {
  }




  getLogo(){
    if(this.payload){
      if(this.payload.logo){
        return this.payload.logo;
      }
    }
    return "https://tomertransport.com/assets/logo.png";
  }

  ngOnInit() {
    this.link = this.route.snapshot.queryParams.l;
    this.loadInfo();
    this.initializeMap();
  }

  calculateDistanceTime(lat, lng) {
    var dest = this.payload.area.destinations[0];
    this.distance = HaversineFormula.getDistanceFromLatLonInKm(lat, lng, dest.lat, dest.lng).toFixed(0);
    this.time = ((this.distance / 40) * 60).toFixed(0);
  }

  loadInfo() {
    this.main.loadTrackingInfo(this.link).then((payload) => {
      this.payload = payload;
      if(this.payload.state == CONSTANTS.TRIP_CREATED){
        new QuickDialog(this.dialog).InfoDialog("The driver has not yet started the trip to share location, once location is being shared this page will update. Press ok to close this message.","Trip Not Started","Ok").then(() =>{
          this.listenForLoactionUpdates();
        })
      }else{
        this.listenForLoactionUpdates();
      }
    }).catch(e => {
      console.log(e);
      new QuickDialog(this.dialog).InfoDialog(e._body,"Unable To View Location","OK");
    })
  }

  listenForLoactionUpdates() {
    this.d = new QuickDialog(this.dialog).LoadingDialog("Awaiting Driver Location");
    this.socketService.connect().then(() => {
      console.log("Connected To Socket IO...");
      if (this.socketService.registerDriverLocationListener()) {
        this.socketService.onDriverLocation.subscribe((data) => {
          if (data) {
            if (data.driverid == this.payload.driverid) {
              var location = new google.maps.LatLng(data.lat, data.lng);
              var currentMarker = this.driverMarkers[data.driverid];
              if (currentMarker) {
                this.d.close();
                currentMarker.infowindow.setPosition({ lat: data.lat, lng: data.lng });
                currentMarker.marker.setPosition({ lat: data.lat, lng: data.lng });
                this.mapControls.centerMapOnLoaction({ lat: data.lat, lng: data.lng });
                this.calculateDistanceTime(data.lat, data.lng);
              } else {
                this.driverMarkers[data.driverid] = this.mapControls.addSimpleDriverMarker(location, data);
              }
            }
          }
        });
      }
    }).catch(e => {
      console.log(e);
    })
  }

  initializeMap() {
    this.mapControls.initialize(this.mapReference);
    let jaLat = 18.9350138;
    let jaLng = -77.7981928;
    this.mapControls.createMapAndCenterOnLoaction(jaLat, jaLng, true, false);
    this.mapControls.centerMapOnCurrentPosition();
  }
}



// WEBPACK FOOTER //
// ./src/app/tracking-link/tracking-link.component.ts